import '../style.scss';
import { Button, ButtonFill, ButtonSize, ButtonType } from 'views/mutual/button';
import { Caption } from 'views/mutual/caption';
import { Description, labelColor, labelSize } from 'views/mutual/description';
import { DisplayItemProps, useEntryConfirm, EntryConfirmProps } from './hooks';
import { useCustomLocationName } from 'views/mutual/location/hooks';
import { CheckLabel, CheckLabelTextSize } from 'views/mutual/checkLabel';

export const EntryConfirm = (props: EntryConfirmProps) => {
  const { agreeToPersonalAccountOpenProfileDetailsProps, execute, goBack, displayInfo } = useEntryConfirm(props);

  useCustomLocationName('口座開設申込みフォーム');

  return (
    <div className="personalAccountOpenTemplate">
      {!props.isUpdate && (
        <>
          <Caption label="申込確認内容" />
          <Description
            label={
              <>
                {' '}
                <a
                  className="personalAccountOpenTemplate_input_wrapper_link"
                  href={process.env.REACT_APP_ELECTORIC_GENERAL_TERMS_CONDITION_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  FPGオンライン取引・電子署名取引一般規約
                </a>
                に同意し、口座開設を申し込みます。
              </>
            }
            labelColor={labelColor.black}
            labelSize={labelSize.large}
          />
        </>
      )}

      <div className="personalAccountOpenTemplate_result">
        {displayInfo.corporateInfo.map((lv) => (
          <DisplayItem {...lv} />
        ))}
      </div>
      {!props.isUpdate && (
        <div className='personalAccountOpenTemplate_checkLabel'>
          <CheckLabel
          {...agreeToPersonalAccountOpenProfileDetailsProps}
          textSize={CheckLabelTextSize.Large}
          before="上記について変更が生じた場合には、貴社に届出ます"
          />
        </div>
      )}
      
      <div className="personalAccountOpenTemplate_button">
        <Button
          type={ButtonType.Submit}
          label={props.isUpdate ? '登録情報変更を更新する' : '口座開設を申込む'}
          buttonFill={ButtonFill.black}
          buttonSize={ButtonSize.medium}
          disable={props.isUpdate ? false : !agreeToPersonalAccountOpenProfileDetailsProps.checked}
          {...execute}
        />
        <Button label="前の画面に戻る" buttonFill={ButtonFill.link} buttonSize={ButtonSize.small} {...goBack} />
      </div>
    </div>
  );
};

const DisplayItem = (props: DisplayItemProps) => {
  const { label, value, hidden } = props;
  if (hidden) return <></>;

  return (
    <>
      <div className="displayItem">
        <div className="displayItem_header">{label}</div>
        <div className="displayItem_body">{value}</div>
      </div>
    </>
  );
};
